import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { Button, Col, Row, Form } from 'react-bootstrap'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import CourseService from '../../service/courseService'
import StudentCourseService from '../../service/studentCourseService'
import StudentCourse from '../../components/StudentCourse/StudentCourse'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import DeleteCourseModal from '../../components/DeleteCourseModal/DeleteCourseModal'
import EditStudentQualified from '../../components/EditStudentQualified/EditStudentQualified'
import DatePicker from 'react-multi-date-picker'
import opacity from 'react-element-popper/animations/opacity'
import thai from '../../components/Utils/DatePicker/thai'
import thai_th from '../../components/Utils/DatePicker/thai_th'
import useToken from '../../App/useToken'
import { successNotify, errorNotify } from '../../components/Utils/Toast'
import CourseTerm from '../../components/CourseTerm/CourseTerm'
import './Course.css'

export default function Course() {
  const {
    isAdmin,
    isUnitAdminOrUnitSpcAdmin,
    getToken,
    isAdminViewer,
    getUserJson,
  } = useToken()
  const isUserAdmin = isAdmin()
  const user = getUserJson()
  const isUserAdminViewer = isAdminViewer()
  const isUserUnitAdminOrUnitSpcAdmin = isUnitAdminOrUnitSpcAdmin()
  const token = getToken()
  const { major_name, course_name } = useParams()
  const [courseInfo, setCourseInfo] = useState([])
  const [studentCourses, setStudentCourses] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isStudentCourseLoading, setIsStudentCourseLoading] = useState(false)
  const [name, setName] = useState('')
  const [fullName, setFullName] = useState('')
  const [yearOfCourse, setYearOfCourse] = useState()
  const [description, setDescription] = useState('')
  const [amount, setAmount] = useState()
  const [terms, setTerms] = useState([])
  const [majorCourseId, setMajorCourseId] = useState()
  const [courseId, setCourseId] = useState()
  const [majorCourseName, setMajorCourseName] = useState()
  const [isSpcApprove, setIsSpcApprove] = useState()
  const [files, setFiles] = useState([])
  const [showDeleteCourseModal, setShowDeleteCourseModal] = useState(false)
  const [qualifications, setQualifications] = useState([])
  const [fetchStudentCourseAt, setFetchStudentCourseAt] = useState()
  const [fetchStudentCourseDisabled, setFetchStudentCourseDisabled] =
    useState(true)

  const [selectedDateTermUnit, setSelectedDateTermUnit] = useState()
  const [selectedEndDateTermUnit, setSelectedEndDateTermUnit] = useState()
  const [selectedDateTermSpc, setSelectedDateTermSpc] = useState()
  const [selectedEndDateTermSpc, setSelectedEndDateTermSpc] = useState()
  const [courseUpdateAvailable, setCourseUpdateAvailable] = useState(false)
  const [userCourseUpdateAvailable, setUserCourseUpdateAvailable] = useState()
  const [majorCourse, setMajorCourse] = useState()

  const getCourseInfo = async () => {
    const courseService = new CourseService()
    const res = await courseService.getCourseByName(course_name, token)
    if (res?.name) {
      setFullName(res.name)
      setBackendResponse(res)
    }
    return res
  }

  useEffect(() => {
    // const updateAvailable =
    //   user?.courseUpdateAvailable?.includes(majorCourse?.pme_no) || !isUserAdmin
    const updateAvailable = user?.courseUpdateAvailable?.includes(
      majorCourse?.pme_no,
    )
    setCourseUpdateAvailable(updateAvailable)
    setUserCourseUpdateAvailable(
      user?.courseUpdateAvailable?.includes(majorCourse?.pme_no),
    )
  }, [majorCourse, user])

  useEffect(() => {
    const getMajorCourseInfo = async () => {
      const courseService = new CourseService()
      const res = await courseService.getInfoByMajorCourseName(
        major_name,
        token,
      )
      setMajorCourse(res)
      if (res.is_spc_approve) {
        setIsSpcApprove(res.is_spc_approve)
      }
    }

    getCourseInfo()
    getMajorCourseInfo(major_name)
  }, [])

  const getStudentCourse = async () => {
    setIsStudentCourseLoading(true)
    const studentCourseService = new StudentCourseService()
    const res = await studentCourseService.getStudentCourseByCourseName({
      course_name,
      token,
    })
    if (res?.studentInTermcourse) {
      setStudentCourses(res.studentInTermcourse)
      setIsStudentCourseLoading(false)
    } else {
      errorNotify('เกิดข้อผิดพลาด')
    }
    return res
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const courseService = new CourseService()
    await courseService
      .editCourse(
        {
          courseId: courseId,
          majorCourseId: majorCourseId,
          majorCourseName: majorCourseName,
          name: fullName,
          description,
          amount,
          // file,
          yearOfCourse,
          terms,
          qualifications,
          stardTermPeriodUnit: selectedDateTermUnit,
          endTermPeriodUnit: selectedEndDateTermUnit,
          stardTermPeriodSpc: selectedDateTermSpc,
          endTermPeriodSpc: selectedEndDateTermSpc,
        },
        token,
        isSpcApprove,
      )
      .then((res) => {
        successNotify('แก้ไขข้อมูลสำเร็จ')
        getStudentCourse()
        getCourseInfo()
      })
      .catch((err) => {
        errorNotify('แก้ไขข้อมูลไม่สำเร็จ')
      })
  }

  const setBackendResponse = async (res) => {
    setCourseInfo(res)
    setName(res.name)
    setDescription(res.description)
    setAmount(res.amount)
    setFiles(res.file)
    setTerms(res.terms)
    setYearOfCourse(res.yearOfCourse)
    setQualifications(res.qualifications)
    setIsLoading(false)
    setMajorCourseId(res.majorCourse)
    setMajorCourseName(res.majorCourseName)
    setCourseId(res._id)
    setSelectedDateTermUnit(res.stardTermPeriodUnit)
    setSelectedEndDateTermUnit(res.endTermPeriodUnit)
    setSelectedDateTermSpc(res.stardTermPeriodSpc)
    setSelectedEndDateTermSpc(res.endTermPeriodSpc)
    setFetchStudentCourseAt(res.fetchStudentsAt)

    const date = Date.now()
    const stardTermDate = new Date(res.stardTermPeriodUnit).getTime()
    console.log('date', date)
    console.log('stardTermDate', stardTermDate)
    // console.log('res.stardTermPeriodUnit', res.stardTermPeriodUnit)

    setFetchStudentCourseDisabled(stardTermDate < date)
  }

  const handleDowloadFile = async (name) => {
    if (name) {
      const courseService = new CourseService()
      const dowloadLink = await courseService.dowloadFile('upload', name)
      window.open(dowloadLink)
    }
  }

  return (
    <div className='main-container'>
      <div className='create-course container'>
        {!isLoading && (
          <div clalssname='container'>
            <Breadcrumb className='course-breadcrumb'>
              <Breadcrumb.Item href='/majorcourses'>Home</Breadcrumb.Item>
              <Breadcrumb.Item href={`/majorcourses/${major_name}`}>
                {major_name}
              </Breadcrumb.Item>
              <Breadcrumb.Item active href='#'>
                {fullName}
              </Breadcrumb.Item>
            </Breadcrumb>
            <DeleteCourseModal
              showDeleteCourseModal={showDeleteCourseModal}
              setShowDeleteCourseModal={setShowDeleteCourseModal}
            />
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <div className='title-container-left'>
                    <span className='title-text'>สถานะการเปิดรับสมัคร</span>
                  </div>
                  <Row className='mb-3'>
                    <Col md={12}>
                      <Form.Group as={Col} controlId='name'>
                        <Form.Label>ชื่อหลักสูตร "{fullName}"</Form.Label>
                        <Form.Control required defaultValue={name} disabled />
                      </Form.Group>
                    </Col>
                    <Col md={7}>
                      <Form.Group controlId='yearOfCourse'>
                        <Form.Label>
                          ปีงบประมาณที่เข้ารับการศึกษา (1 ต.ค. - 30 ก.ย.)
                        </Form.Label>
                        <Form.Control
                          type='number'
                          min='2565'
                          max='2585'
                          required
                          defaultValue={yearOfCourse}
                          disabled
                        />
                      </Form.Group>
                    </Col>
                    <Col md={5}>
                      <Form.Group as={Col} controlId='amount'>
                        <Form.Label>จำนวนผู้เข้ารับการศึกษา(ทั้งปี)</Form.Label>
                        <Form.Control
                          type='number'
                          min='1'
                          value={amount}
                          readOnly
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Form.Group
                        as={Col}
                        controlId='description'
                        onChange={(e) => setDescription(e.target.value)}>
                        <Form.Label>คำอธิบาย</Form.Label>
                        <Form.Control
                          as='textarea'
                          rows={10}
                          disabled={!userCourseUpdateAvailable}
                          defaultValue={description}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group controlId='file'>
                    <Form.Label>แนบคำสั่ง</Form.Label>
                    <br />
                    <span>
                      {files !== [] &&
                        files.map((file, index) => (
                          <a
                            key={index}
                            onClick={(e) => handleDowloadFile(file)}
                            className='dowload-file'>
                            {file}
                          </a>
                        ))}
                      {files[0] === null && <span> - </span>}
                    </span>
                  </Form.Group>

                  {/* HotFix Todo Verify */}
                  <Row>
                    <Form.Group as={Col}>
                      <Form.Label>เปิดสมัครหน่วย</Form.Label>
                      <br />
                      <DatePicker
                        inputClass='form-control'
                        // calendar={thai}
                        locale={thai_th}
                        required
                        format='DD/MMMM/YYYY'
                        animations={[opacity()]}
                        value={selectedDateTermUnit}
                        disabled={!userCourseUpdateAvailable}
                        onChange={(date) =>
                          setSelectedDateTermUnit(
                            new Date(date.year, date.month.index, date.day),
                          )
                        }
                      />
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label>หมดเขตสมัครหน่วย</Form.Label>
                      <br />
                      <DatePicker
                        inputClass='form-control'
                        // calendar={thai}
                        locale={thai_th}
                        required
                        format='DD/MMMM/YYYY'
                        animations={[opacity()]}
                        value={selectedEndDateTermUnit}
                        disabled={!userCourseUpdateAvailable}
                        onChange={(date) =>
                          setSelectedEndDateTermUnit(
                            new Date(
                              // date.year - 543,
                              date.year,
                              date.month.index,
                              date.day,
                            ),
                          )
                        }
                      />
                    </Form.Group>
                  </Row>
                  {isSpcApprove && (
                    <Row>
                      <Form.Group as={Col}>
                        <Form.Label>เปิดสมัครสาย</Form.Label>
                        <br />
                        <DatePicker
                          inputClass='form-control'
                          // calendar={thai}
                          locale={thai_th}
                          required
                          format='DD/MMMM/YYYY'
                          animations={[opacity()]}
                          value={selectedDateTermSpc}
                          disabled={!userCourseUpdateAvailable}
                          onChange={(date) =>
                            setSelectedDateTermSpc(
                              new Date(date.year, date.month.index, date.day),
                            )
                          }
                        />
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Form.Label>หมดเขตสมัครสาย</Form.Label>
                        <br />
                        <DatePicker
                          inputClass='form-control'
                          // calendar={thai}
                          locale={thai_th}
                          required
                          format='DD/MMMM/YYYY'
                          animations={[opacity()]}
                          value={selectedEndDateTermSpc}
                          disabled={!userCourseUpdateAvailable}
                          onChange={(date) =>
                            setSelectedEndDateTermSpc(
                              new Date(date.year, date.month.index, date.day),
                            )
                          }
                        />
                      </Form.Group>
                    </Row>
                  )}
                </Col>
                {/* HotFix Todo Verify */}
                <Col md={6}>
                  <div className='title-container-right'>
                    <span className='title-text'>
                      คุณสมบัติที่หลักสูตรกำหนด
                    </span>
                  </div>
                  <Row className='mb-3'>
                    <EditStudentQualified
                      setQualifications={setQualifications}
                      qualifications={qualifications}
                      token={token}
                      isUserAdmin={isUserAdmin}
                    />
                  </Row>
                </Col>
              </Row>
              <Row className='add-term'>
                <div>
                  รุ่น
                  <FontAwesomeIcon icon={faPlus} />
                </div>
                <hr />
              </Row>

              <CourseTerm
                setAmount={setAmount}
                setTerms={setTerms}
                terms={terms}
              />

              <div className='submit-container'>
                {isUserAdmin && courseUpdateAvailable && (
                  <div className='btn-edit'>
                    <Button variant='primary' type='submit'>
                      บันทึกหลักสูตร
                    </Button>
                  </div>
                )}

                {isUserAdmin && courseUpdateAvailable && (
                  <div className='btn-delete'>
                    <Button
                      variant='danger'
                      onClick={() => setShowDeleteCourseModal(true)}>
                      ลบหลักสูตร
                    </Button>
                  </div>
                )}
              </div>
            </Form>
          </div>
        )}
      </div>
      {(isUserAdmin || isUserUnitAdminOrUnitSpcAdmin || isUserAdminViewer) && (
        <div className='student-container-group'>
          <div className='student-container'>
            <div>
              <StudentCourse
                courseUpdateAvailable={courseUpdateAvailable}
                fetchStudentCourseAt={fetchStudentCourseAt}
                courseId={courseId}
                studentCourses={studentCourses}
                setStudentCourses={setStudentCourses}
                isStudentCourseLoading={isStudentCourseLoading}
                setIsStudentCourseLoading={setIsStudentCourseLoading}
                courseInfo={courseInfo}
                fetchStudentCourseDisabled={fetchStudentCourseDisabled}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
